import React, { ReactElement, ReactNode, useState } from "react"
import Popover from "@mui/material/Popover"

interface CalendarPopoverProps {
  buttonElement: (props: { onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void }) => ReactElement
  anchorOrigin?: {
    vertical: "top" | "center" | "bottom"
    horizontal: "left" | "center" | "right"
  }
  transformOrigin?: {
    vertical: "top" | "center" | "bottom"
    horizontal: "left" | "center" | "right"
  }
  children: ReactNode
}

const CalendarPopover: React.FC<CalendarPopoverProps> = ({
  buttonElement,
  anchorOrigin = {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin = {
    vertical: "top",
    horizontal: "center",
  },
  children,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const [open, setOpen] = useState(false)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget)
    setOpen(true)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setOpen(false)
  }

  return (
    <div data-testid="calendar-popover-container">
      {buttonElement({ onClick: handleClick })}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        data-testid="calendar-popover-popover"
      >
        {children}
      </Popover>
    </div>
  )
}

export default CalendarPopover
